import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { decryptData } from "../component/DecryptMedSmart"; // นำเข้า function ถอดรหัส
import axios from "axios";
import ip from '../ipserver';
import { useNavigate } from 'react-router-dom';
import * as Loading from "../component/Loading.json";
import * as Fail from "../component/Fail.json";
import Lottie from "react-lottie";
import "../css/FromMedSmart.css";
import { useLogin } from '../component/LoginContext';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Loading.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
};

const defaultOptions2 = {
    loop: false,
    autoplay: true,
    animationData: Fail.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };


const CheckLogin = () => {
    const ipserver = ip;
    const { encryptedData } = useParams();
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [hn,setHn] = useState('');
    const navigate = useNavigate();
    const [failLogin , setFailLogin] = useState(false);
    const { login } = useLogin();
    const [loading , setLoading] = useState(true);
    const [showFailAnimation, setShowFailAnimation] = useState(false); // สำหรับแสดง Fail animation หลังจากหน่วงเวลา
    const [isDecryptComplete, setIsDecryptComplete] = useState(false);

    const delayFailAnimation = () => {
        setTimeout(() => {
            setShowFailAnimation(true);
        }, 2000);
    };

    // First useEffect for initial parameter validation
    useEffect(() => {
        if (!encryptedData) {
            setLoading(false);
            delayFailAnimation();
            navigate("/");
        }
        console.log(encryptedData);
        try {
            const encParam = encryptedData.split('Enc=')[1];
            if (!encParam) {
                setLoading(false);
                delayFailAnimation();
                navigate("/");
            }
            
            // Decrypt and set all required data
            const decryptedData = decryptData(decodeURIComponent(encParam));
            const userData = decryptedData.split(";");
            
            const userInfo = userData[0].split("=")[1]?.trim();
            const passwordInfo = userData[1].split("=")[1]?.trim();
            const hnInfo = userData[2].split("=")[1]?.trim();
            
            const cleanedUser = userInfo.replace(/'/g, "");
            const cleanedPwd = passwordInfo.replace(/'/g, "");
            const cleanedHn = hnInfo.replace(/'/g, "");
            
            setUser(cleanedUser);
            setPwd(cleanedPwd);
            setHn(cleanedHn);
            console.log(decryptedData);
            setIsDecryptComplete(true);
            
        } catch (error) {
            console.error('Error processing encrypted data:', error);
            setLoading(false);
            delayFailAnimation();
        }
    }, [encryptedData]);

    // Second useEffect for authentication
    useEffect(() => {
        const checkuser = async () => {
            if (!user || !pwd || !isDecryptComplete) {
                return;
            }
            console.log(user)
            console.log(pwd)
            console.log(hn)
            try {
                setLoading(true);
                const response = await axios.get(`https://${ipserver}/api/users`, {
                    params: {
                        user: user,
                        pwd: pwd
                    }
                });

                if (response.data.success === true) {
                    login({ name: user },{pass:pwd},{passCode: response.data.passcode});
                    if (hn) {
                        navigate(`/worklist/${response.data.passCode}/${hn}`);
                    } else {
                        navigate(`/worklist/${response.data.passCode}`);
                        
                    }
                } else {
                    setLoading(false);
                    setFailLogin(true);
                    delayFailAnimation();
                    navigate("/");
                }
            } catch (error) {
                console.error("Authentication error:", error);
                setLoading(false);
                delayFailAnimation();
                navigate("/");
            }
        };

        checkuser();
    }, [user, pwd, hn, isDecryptComplete, ipserver, navigate, login]);


    return (
        <div className="lottie-container">
            {loading ? (
                <Lottie options={defaultOptions} /> // แสดง Loading animation ขณะโหลด
            ) : showFailAnimation ? (
                <>
                    <Lottie options={defaultOptions2} />
                    {failLogin ? (
                        <>
                            <h3 className="failtext">Username or Password is invalid.</h3> 
                            <h4 className="failtext">Please Login and try again.</h4>
                        </>)
                    : (
                    <>
                        <h3 className="failtext">Something went wrong.</h3> 
                        <h4 className="failtext">Please Login and try again.</h4>
                    </>
                    )}
                    
                </>
            ) : (
                <Lottie options={defaultOptions} /> // แสดง Loading animation ระหว่างหน่วงเวลา
            )}
        </div>
    );
};

export default CheckLogin;
